import type { OverviewState, RevenueData } from '../types'
import { getMonthAbbreviation } from './getMonthAbbreviation'

export const getOverviewDataToDispatch = (
  overviewData: OverviewState
): OverviewState => {
  if (
    !overviewData.overview?.revenue ||
    Object.keys(overviewData.overview.revenue).length === 0
  ) {
    return overviewData
  }

  return {
    ...overviewData,
    overview: {
      ...overviewData.overview,
      revenue: {
        ...overviewData.overview.revenue,
        revenueData: overviewData.overview.revenue.revenueData.map(
          (item: RevenueData) => ({
            ...item,
            data: item.data.map(({ date, value }) => ({
              x: getMonthAbbreviation(date),
              y: value,
            })),
          })
        ),
      },
    },
  } as unknown as OverviewState
}
